export default {"src":"/_next/static/media/GTLB.05bacbf6.svg","height":18,"width":18};